import type { DataCard, PersonaCard, UserCardValues } from '@youscience/bpa-common';

export const selectUserCard = (cards?: DataCard[]): UserCardValues | undefined => {
  if (!cards?.length) {
    return undefined;
  }

  return cards.find((card): card is Extract<DataCard, { type: 'user' }> => card.type === 'user')?.values;
};

export const selectPersonaCard = (cards?: DataCard[], tenantId?: string): PersonaCard | undefined => {
  if (!cards?.length || !tenantId) {
    return undefined;
  }

  return cards.find(
    (card): card is Extract<DataCard, { type: 'persona' }> => card.type === 'persona' && card.tenantId === tenantId,
  );
};
